import {
  Component,
  Inject,
  OnInit,
  PLATFORM_ID
} from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators
} from '@angular/forms';
import {
  isPlatformBrowser,
  CommonModule
} from '@angular/common';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';

import { Options } from '../../Models/options.model';
import { UserProfileModel } from '../../Models/user-data.model';
import { CreditGeniusService } from '../../../Services/credit-genius.service';
import { CryptographyService } from '../../../Services/cryptography.service';
import { CommonHelperService } from '../../CommonUtility/common-helper.service';
import { PageType, StatusCode } from '../../Models/EnumHelper';
import { isNumber, padNumber } from '../../CommonUtility/util';
import { environment } from '../../../environments/environment';
import { NavbarComponent } from '../../Components/navbar/navbar.component';
import { FooterComponent } from '../../Components/footer/footer.component';

@Component({
  selector: 'app-personal-details',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    NavbarComponent,
    FooterComponent
  ],
  templateUrl: './personal-details.component.html',
  styleUrls: ['./personal-details.component.css']
})
export class PersonalDetailsComponent implements OnInit {
  imgSrc = environment.imgBasURL;
  navType: PageType = PageType.personal;
  PersonalDetailForm!: FormGroup;
  submitted = false;
  ageComment = '';
  selectedOption!: Options;

  IsImageLoaded = false;
  IsMobileNoNotValid = false;
  IsMobileNoRequired = false;
  IsMobBtnValid = true;
  IsEmailValid = true;
  IsPhoneValid = true;
  EmailMessage = false;
  requiredMsg = false;
  InvalidDate = false;
  showDob = false;
  RequiredDobMsg = false;
  FN_ErrorMsg = false;
  FN_InvalidMsg = false;
  LN_ErrorMsg = false;
  LN_InvalidMsg = false;

  options: Options[] = [
    { id: 1, name: 'Mr', isSelect: true },
    { id: 2, name: 'Mrs', isSelect: false },
    { id: 3, name: 'Ms', isSelect: false },
    { id: 4, name: 'Miss', isSelect: false }
  ];

  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private crypto_service: CryptographyService,
    private _creditGeniusService: CreditGeniusService,
    private _commonHelper: CommonHelperService,
    private route: ActivatedRoute,
    @Inject(PLATFORM_ID) private platformId: Object
  ) { }

  ngOnInit(): void {
    this.selectedOption = this.options[0];
    this.PersonalDetailForm = this.formBuilder.group({
      Title: [''],
      FName: ['', Validators.required],
      LName: ['', Validators.required],
      DateOfBirth: ['', Validators.required],
      Email: ['', [Validators.required, Validators.email, Validators.pattern('^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$')]],
      MobileNo: ['', Validators.required]
    });

    this.route.queryParams.subscribe(params => {
      if (isPlatformBrowser(this.platformId) && params?.['tag'] === 'back') {
        const newUrl = location.protocol + '//' + location.host + location.pathname;
        history.pushState({ path: newUrl }, '', newUrl);

        const userProfile = this._commonHelper.GetPersonalDetail();
        if (userProfile) {
          this.PersonalDetailForm.patchValue({
            Title: userProfile.Title,
            FName: userProfile.FName,
            LName: userProfile.LName,
            DateOfBirth: userProfile.DateOfBirth,
            Email: userProfile.Email,
            MobileNo: userProfile.Mobile
          });
          this.checkMob(userProfile.Mobile);
        }
      }
    });

    if (isPlatformBrowser(this.platformId)) {
      window.scrollTo(0, 0);
    }
  }

  get f() {
    return this.PersonalDetailForm.controls;
  }

  onSubmit() {
    this.submitted = true;
    this.IsImageLoaded = true;
    this.IsEmailValid = true;
    this.IsPhoneValid = true;

    if (this.PersonalDetailForm.invalid) {
      this.IsImageLoaded = false;
      return;
    }

    const personalDetail: UserProfileModel = {
      UserName: this.crypto_service.encrypt(this.f['Email'].value),
      Title: this.selectedOption.name,
      FName: this.f['FName'].value,
      LName: this.f['LName'].value,
      DateOfBirth: this.getDateOfBirthUTC(this.f['DateOfBirth'].value) ?? undefined,
      Email: this.f['Email'].value,
      Mobile: this.f['MobileNo'].value
    };

    this.router.navigate(['/address']); //TODO: remove this line when the service is ready
    // TODO: Uncomment the following code when the service is ready

    // this._creditGeniusService.SavePersonalDetail(personalDetail).subscribe(
    //   (result: any) => {
    //     this.IsImageLoaded = false;
    //     if (result?.statusCode === StatusCode.Success) {
    //       sessionStorage.setItem('customer', result.data[0].customerId);
    //       personalDetail.DateOfBirth = this.f['DateOfBirth'].value;
    //       this._commonHelper.SetPersonalDetails(personalDetail);
    //       this.router.navigate(['/address']);
    //     } else if (result?.statusCode === StatusCode.InvalidEmail) {
    //       this.IsEmailValid = false;
    //       this.f['Email'].setErrors({ incorrect: true });
    //     } else if (result?.statusCode === StatusCode.InvalidPhone) {
    //       this.IsPhoneValid = false;
    //       this.f['MobileNo'].setErrors({ incorrect: true });
    //     }
    //   },
    //   (err: HttpErrorResponse) => {
    //     this.IsImageLoaded = false;
    //     console.error('Error occurred:', err);
    //   }
    // );
  }

  checkMob(mobile: any) {
    if (!mobile) {
      this.IsMobileNoRequired = true;
      this.IsMobileNoNotValid = false;
    } else if (!/^(07)[0-9]{9}$/.test(mobile)) {
      this.IsMobileNoRequired = false;
      this.IsMobileNoNotValid = true;
    } else {
      this.IsMobBtnValid = false;
      this.IsMobileNoRequired = false;
      this.IsMobileNoNotValid = false;
    }
  }

  getDateOfBirthUTC(dateformat: any): Date | null {
    if (!dateformat) return null;
    const [day, month, year] = dateformat.split('/').map((v: string) => parseInt(v));
    if (isNaN(day) || isNaN(month) || isNaN(year)) return null;
    return new Date(`${padNumber(month)}/${padNumber(day)}/${year} UTC`);
  }

  ClickTitle(optionId: number) {
  this.options.forEach(option => {
    option.isSelect = (option.id === optionId);
  });
  this.selectedOption = this.options.find(option => option.id === optionId)!;
}

keyDownFunction(event: any) {
  const controlId = event.target.id;
  const controlValue = (event.target.value || '').trim().replace(/\s\s+/g, ' ');

  if (controlId === 'first-name') {
    if (!controlValue) {
      this.PersonalDetailForm.controls['FName'].setErrors({ 'incorrect': true });
      this.FN_ErrorMsg = true;
    } else {
      this.FN_InvalidMsg = controlValue.split(' ').some((part: string) => part.length < 2);
      if (this.FN_InvalidMsg) {
        this.PersonalDetailForm.controls['FName'].setErrors({ 'incorrect': true });
      }
    }
  } else if (controlId === 'last-name') {
    if (!controlValue) {
      this.PersonalDetailForm.controls['LName'].setErrors({ 'incorrect': true });
      this.LN_ErrorMsg = true;
    } else {
      this.LN_InvalidMsg = controlValue.split(' ').some((part: string) => part.length < 2);
      if (this.LN_InvalidMsg) {
        this.PersonalDetailForm.controls['LName'].setErrors({ 'incorrect': true });
      }
    }
  }
}

focusEvent(): void {
  this.RequiredDobMsg = false;
  this.InvalidDate = false;
  this.showDob = false;
}

dateofbirth(event: any): void {
  const targetValue: string = event.target.value;
  if (!targetValue) {
    this.RequiredDobMsg = true;
    this.showDob = false;
    this.InvalidDate = false;
    return;
  }

  const [dayStr, monthStr, yearStr] = targetValue.split('/');
  const day = parseInt(dayStr);
  const month = parseInt(monthStr);
  const year = parseInt(yearStr);

  const checkDate = new Date(year, month - 1, day);
  const convertedDate = `${checkDate.getFullYear()}${checkDate.getMonth() + 1}${checkDate.getDate()}`;
  const givenDate = `${year}${month}${day}`;

  if (convertedDate !== givenDate) {
    this.InvalidDate = true;
    return;
  }

  if (day >= 1 && day <= 31 && month >= 1 && month <= 12 && yearStr.length === 4) {
    const formattedDOB = `${month < 10 ? '0' : ''}${month}/${day < 10 ? '0' : ''}${day}/${year}`;
    this.ValidateAge(formattedDOB);
  } else {
    this.InvalidDate = true;
    this.showDob = false;
  }
}
onlyNumbers(event: KeyboardEvent): boolean {
  const charCode = event.charCode || event.keyCode;
  return charCode >= 48 && charCode <= 57 || charCode === 47; // allows numbers and '/'
}

ValidateAge(dob: string): void {
  this.InvalidDate = false;

  if (!dob) {
    this.showDob = false;
    return;
  }

  const dobDate = new Date(dob);
  const ageDiffMs = Date.now() - dobDate.getTime();
  const ageDate = new Date(ageDiffMs);
  const age = ageDate.getUTCFullYear() - 1970;

  if (age < 18 && age >= 0) {
    this.PersonalDetailForm.controls['DateOfBirth'].setErrors({ incorrect: true });
    this.showDob = true;
    this.ageComment = 'You need to be at least 18 to proceed';
  } else if (age > 100) {
    this.PersonalDetailForm.controls['DateOfBirth'].setErrors({ incorrect: true });
    this.showDob = true;
    this.ageComment = 'Please enter a valid date of birth';
  } else if (age < 0) {
    this.PersonalDetailForm.controls['DateOfBirth'].setErrors({ incorrect: true });
    this.InvalidDate = true;
  } else {
    this.showDob = false;
  }
}

Slash(event: KeyboardEvent): void {
  const input = event.target as HTMLInputElement;
  let value = input.value.replace(/[^0-9]/g, '');

  if (event.key === 'Backspace') {
    return;
  }

  if (value.length === 2 || value.length === 3) {
    input.value = value.replace(/(\d{2})/, '$1/');
  }

  if (value.length >= 4) {
    input.value = value.replace(/(\d{2})(\d{2})/, '$1/$2/');
  }
}

onEmailChange(event: any): void {
  const email = event.target.value?.trim();
  if (!email) {
    this.requiredMsg = true;
    this.EmailMessage = false;
    return;
  }

  this.requiredMsg = false;
  this.IsEmailValid = true;

  const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  if (!emailPattern.test(email)) {
    this.EmailMessage = true;
    return;
  }

  this.EmailMessage = false;
  this.submitted = false;
}
checkMobileNo(mobile: string): void {
  if (!mobile) {
    this.IsMobileNoRequired = false;
    this.IsMobBtnValid = true;
    return;
  }

  const pattern = /^(07)[0-9]{9}$/;
  if (!pattern.test(mobile)) {
    this.IsMobileNoNotValid = false;
    this.IsMobBtnValid = true;
  } else {
    this.PersonalDetailForm.controls['MobileNo'].setValue(mobile);
    this.IsMobBtnValid = false;
    this.IsMobileNoRequired = false;
    this.IsMobileNoNotValid = false;
  }
}

}